<template>
  <div class="media-player">
    <p class="play-input">
      <input type="radio"
             name="futuri-player-is-playing-{{index}}"
             id="futuri-player-is-playing-{{index}}-1"
             v-bind:checked="isPlaying"
             value="play"
             v-on:click="play">
      <label class="play-button" for="futuri-player-is-playing-{{index}}-1">Play</label>

      <input type="radio"
             name="futuri-player-is-playing-{{index}}"
             id="futuri-player-is-playing-{{index}}-2"
             v-bind:checked="!isPlaying"
             value="pause"
             v-on:click="pause">
      <label class="pause-button" for="futuri-player-is-playing-{{index}}-2">Pause</label>
    </p>
    <scrubber v-bind:position="seekPosition"
              v-bind:duration="duration"
              v-bind:playing-live-stream="playingLiveStream"
              v-on:seeking="onSeeking">
    </scrubber>
    <p class="time-remaining-input">
      <span v-if="!playingLiveStream">-{{ formattedTimeLeft }}</span>
      <span v-else>LIVE</span>
    </p>
    <!--
    <p class="share-input">
      <a href="javascript:void(0);">Share</a>
    </p>
  -->
  </div>
</template>

<script>
import Scrubber from './scrubber';

export default {
  components: { Scrubber },
  props: ['station', 'id', 'index', 'duration', 'dropToLive', 'isPlaying', 'seekPosition', 'timeLeft', 'playingLiveStream'],
  data() {
    return {
      buffering: false,
      time: null,
    };
  },
  computed: {
    formattedTimeLeft() {
      let sec = this.timeLeft;

      const hours = Math.floor(sec / 3600.0);
      sec -= hours * 3600.0;
      const minutes = Math.floor(sec / 60.0);
      sec -= minutes * 60.0;

      const zeroPad = (value) => {
        const str = Math.floor(value).toString();
        if (str.length < 2) {
          return `0${str}`;
        }
        return str;
      };
      const text = `${zeroPad(minutes)}:${zeroPad(sec)}`;
      if (hours > 0) {
        return `${Math.floor(hours).toString()}:${text}`;
      }
      return text;
    },

    playState: {
      set() {},

      get() {
        return this.isPlaying ? 'playing' : 'paused';
      },
    },
  },
  methods: {
    /**
     * Event emitted when toggling play/pause.
     */
    togglePlay() {
      return this.isPlaying ? this.play() : this.pause();
    },

    /**
     * Emit play event.
     */
    play() {
      this.$emit('play');
    },

    /**
     * Emit pause event.
     */
    pause() {
      this.$emit('pause');
    },

    /**
     * Event emitted when seeking through audio.
     * @param pos
     */
    onSeeking(pos) {
      this.$emit('seeking', pos);
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  .faded-background(@color) { background: @color; background: linear-gradient(@color, fade(@color, 50%)); }

  * {box-sizing: border-box; margin: 0; padding: 0;}

  .media-player {
    display: none;
    position: absolute;
    bottom: 0;
    left:0;
    width: 100%;
    border-radius: 0 0 10px 10px;
    overflow: hidden;
    padding: 0;
    margin: 0;
    font-size: 0;

    p {
      display: inline-block;
      vertical-align: top;
      line-height: 42px;
      height: 42px;
      .faded-background(black);
      color: white;
      background-clip: padding-box;
      border-right: solid 1px rgba(255, 255, 255, .3);
      padding: 0;
      margin: 0;

      &.play-input {
        width: 42px;

        input[type=radio] {
          display: none;
        }

        label {
          font-size: 0;
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          cursor: pointer;

          &.pause-button {
            &:after {
              content: "";
              background-image: url(../assets/pause.svg);
              background-size: cover;
              width: 16px;
              height: 16px;
              margin-top: 13px;
              display: inline-block;
            }
          }
          &.play-button {
            &:after {
              content: "";
              background-image: url(../assets/play.svg);
              background-size: cover;
              width: 16px;
              height: 16px;
              margin-top: 13px;
              display: inline-block;
            }
          }
        }

        input[type=radio]:checked + label {
          display: none;
        }

        &:hover {
          .faded-background(lighten(black, 40%));
        }
      }

      &.scrub-input {
        width: ~"calc(100% - 42px - 72px)"; // - 42px
        padding: 3px 16px;
        input {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
      }

      &.time-remaining-input {
        width: 72px;
        border-right: 0;

        span {
          font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
          font-weight: normal;
          font-size: 12px;
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
        }
      }
      /*
      &.share-input {
        width: 42px;
        border-right: 0;

        a {
          font-size: 0;
          display: block;
          width: 100%;
          height: 100%;
          text-align: center;
          cursor: pointer;
          border: none;
          background: none;
          color: white;
          text-decoration: none;

          &:after {
            content: "";
            background-image: url(../assets/share-alt.svg);
            background-size: cover;
            width: 16px;
            height: 16px;
            display: inline-block;
            margin-top: 13px;
          }
        }

        &:hover {
          .faded-background(lighten(black, 40%));
        }
      }
      */
    }
  }
</style>



// WEBPACK FOOTER //
// media_player.vue?2e040976